import {
  FirstAndLastNameCell,
  DevicesCell,
  RootProjectCell,
  EmailCell,
  LogsCell,
  EditCell
} from './user';

export const userTableHeadMap = {
  firstAndLastName: FirstAndLastNameCell,
  devices: DevicesCell,
  rootProject: RootProjectCell,
  email: EmailCell,
  trail: LogsCell,
  edit: EditCell
};
